<template>
  <div>
    <el-dialog
      v-model="dialogFormVisible"
      :close-on-click-modal="false"
      title="公寓订单详情"
      width="80%"
      @close="close"
    >
      <el-row>
        <el-col :span="6">订单号:</el-col>
        <el-col :span="6">
          <h1 class="order-no">
            {{ showForm.basic && showForm.basic.orderNo }}
          </h1>
        </el-col>
        <el-col :span="6">订单标题:</el-col>
        <el-col :span="6">
          <h1 class="order-no">{{ showForm.title }}</h1>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="6">订单金额:</el-col>
        <el-col :span="6">
          {{showUpload?'$':'£'}}{{ formatPrice(showForm.amount && showForm.amount.totalAmount) }}
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="6">提交时间:</el-col>
        <el-col :span="6">
          {{ moment(showForm.created).format('YYYY-MM-DD HH:mm:ss') }}
        </el-col>
      </el-row>
      <div class="main-task" v-if="showForm.basic && showForm.basic.roomList">
        <el-row>
          <el-col :span="6">房型名称</el-col>
          <el-col :span="6">公寓名称</el-col>
          <el-col :span="4">入住日期</el-col>
          <el-col :span="4">租期/单价</el-col>
          <el-col :span="4">楼层</el-col>
        </el-row>
        <div
          v-for="(item, index) in showForm.basic.roomList"
          :key="index"
          class="single-product"
        >
          <el-row style="margin-top: 0px" v-if="item.title">
            <el-col :span="6">
              <h1 class="order-no">{{ item.title }}</h1>
            </el-col>
            <el-col :span="6">
              <h1 class="order-no">{{ showForm.basic.apartmentTitle || '' }}</h1>
            </el-col>
            <el-col :span="4">
              <h1 class="order-no">{{ showForm.basic.arrDate || '' }}</h1>
            </el-col>
            <el-col :span="4">
              <h1 class="order-no">
                {{ item.price && item.price.lease }}{{showForm.basic.period==1?'周':'个月'}}/{{showUpload?'$':'£'}}{{
                  item.price && item.price.price
                }}
              </h1>
            </el-col>
            <el-col :span="4">
              <h1 class="order-no">
                {{
                  item.price && item.price.text
                }}
              </h1>
            </el-col>
          </el-row>
        </div>
        <!-- <p>共{{ showForm.basic.roomList.length }}种商品</p> -->
      </div>
      <el-row>
        <el-col :span="6">备注:</el-col>
        <el-col :span="18">
          {{ (showForm.basic && showForm.basic.text) || '无' }}
        </el-col>
      </el-row>
      <el-row style="margin-top: 5px">
        <el-col :span="6">订单状态:</el-col>
        <el-col :span="6">
          <el-tag type="primary" v-if="showForm.step == 1">待付款</el-tag>
          <el-tag type="success" v-if="showForm.step == 2">已预约</el-tag>
          <el-tag type="warning" v-if="showForm.step == 3">待注册</el-tag>
          <el-tag type="warning" v-if="showForm.step == 4">已完成</el-tag>
          <el-tag type="danger" v-if="showForm.step == 5">已退款</el-tag>
          <el-tag type="info" v-if="showForm.step == 6">已取消</el-tag>
          <el-tag type="warning" v-if="showForm.step == 8">退款中</el-tag>
          <el-tag type="warning" v-if="showForm.step == 9">待确认</el-tag>
        </el-col>
        <template v-if="showForm.step == 4">
          <el-col :span="6">完成时间:</el-col>
          <el-col :span="6">
            {{
              moment(showForm.extra && showForm.extra.finishTime).format(
                'YYYY-MM-DD HH:mm:ss'
              )
            }}
          </el-col>
        </template>
      </el-row>
      <!-- 用户信息 -->
      <el-row
        style="margin-top: 5px"
        v-if="showForm.people"
      >
        <el-col :span="6">用户信息:</el-col>
        <el-col :span="18">
          <el-avatar :size="64" :src="showForm.people&&showForm.people.avatar"></el-avatar>
          <p>
            {{
              showForm.people&&showForm.people.name ||
              '未知'
            }}
          </p>
          <el-button type="primary" @click="tokf">客服回复</el-button>
        </el-col>
      </el-row>
      <el-row
        style="margin-top: 5px"
        v-if="showForm.basic && showForm.basic.contact"
      >
        <el-col :span="6">联系方式:</el-col>
        <el-col :span="18">
          <p>
            姓名：{{
              (showForm.basic &&
                showForm.basic.contact &&
                showForm.basic.contact.name) ||
              '未填写'
            }}
          </p>
          <p>
            性别：{{
              (showForm.basic &&
                showForm.basic.contact &&
                showForm.basic.contact.gender) ||
              '未填写'
            }}
          </p>
          <p>
            生日：{{
              (showForm.basic &&
                showForm.basic.contact &&
                showForm.basic.contact.birthday) ||
              '未填写'
            }}
          </p>
          <p>
            手机号：{{
              (showForm.basic &&
                showForm.basic.contact &&
                showForm.basic.contact.tel) ||
              '未填写'
            }}
          </p>
          <p>
            微信号：{{
              (showForm.basic &&
                showForm.basic.contact &&
                showForm.basic.contact.wechat) ||
              '未填写'
            }}
          </p>
          <p>
            邮箱：{{
              (showForm.basic &&
                showForm.basic.contact &&
                showForm.basic.contact.email) ||
              '未填写'
            }}
          </p>
        </el-col>
      </el-row>
      <!-- 额外信息 -->
      <el-row
        style="margin-top: 5px"
        v-if="
          showForm.basic &&
          showForm.basic.orderExtraInfo &&
          showForm.basic.orderExtraInfo.length > 0
        "
      >
        <el-col :span="6">额外信息:</el-col>
        <el-col :span="18">
          <p
            v-for="(item, index) of showForm.basic.orderExtraInfo"
            :key="index"
          >
            {{ item.title }}：{{ item.value || '未填写' }}
          </p>
        </el-col>
      </el-row>
      <!-- 额外信息 -->
      <template #footer>
        <el-button
          type="primary"
          v-if="showForm.step === 2 || showForm.step === 3"
          @click="verifyOrder"
          style="float: left"
        >
          完成
        </el-button>
        <el-button
          type="primary"
          v-if="showForm.step === 9"
          @click="confirmVisible = true"
          style="float: left"
        >
          确认订单
        </el-button>
        <!-- <el-button
          v-if="checkRefund()"
          style="float: left"
          type="warning"
          @click="handleRefund"
        >
          退款
        </el-button> -->
        <el-button
          style="float: left"
          v-if="showForm.step === 2&&showUpload"
          @click="uploadVisible = true"
        >
          上传收据和手册
        </el-button>
        <el-button
          style="float: left"
          v-if="showForm.basic && showForm.basic.receipt"
          @click="handlePdf(showForm.basic.receipt, '订单收据')"
        >
          查看订单收据
        </el-button>
        <el-button
          style="float: left"
          v-if="showForm.basic && showForm.basic.tutorial"
          @click="handlePdf(showForm.basic.tutorial, '注册指导手册')"
        >
          查看指导手册
        </el-button>
        <!-- <el-button
          style="float: left"
          v-if="showForm.step === 9 || showForm.step === 1"
          @click="handleCancel"
          type="warning"
        >
          取消订单
        </el-button> -->
        <el-button @click="close">关闭</el-button>
      </template>
    </el-dialog>
    <el-dialog title="订单确认" v-model="confirmVisible" width="60%">
      <el-form label-width="80px">
        <el-form-item label="定金金额">
          <el-input
            v-model="confirmAmount"
            placeholder="请输入定金金额"
            class="fix-width"
          ></el-input>
          元
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="confirmVisible = false">取 消</el-button>
        <el-button
          :loading="confirmLoading"
          type="primary"
          @click="confirmOrder"
        >
          确 认
        </el-button>
      </template>
    </el-dialog>
    <el-dialog
      title="上传订单收据和注册指导手册"
      v-model="uploadVisible"
      width="60%"
    >
      <el-form label-width="100px">
        <el-form-item label="订单收据">
          <el-upload
            class="upload-demo"
            :action="QNUploadURL"
            :data="receiptToken"
            :limit="1"
            :file-list="receiptForm.fileList"
            :on-success="uploadReceiptSuccess"
            :before-upload="beforeUpload"
          >
            <el-button size="small" type="primary">点击上传</el-button>
            <div class="el-upload__tip">只能上传pdf文件</div>
          </el-upload>
        </el-form-item>
        <el-form-item label="注册指导手册">
          <el-upload
            class="upload-demo"
            :action="QNUploadURL"
            :data="tutorialToken"
            :limit="1"
            :file-list="tutorialForm.fileList"
            :on-success="uploadTutorialSuccess"
            :before-upload="beforeUpload"
          >
            <el-button size="small" type="primary">点击上传</el-button>
            <div class="el-upload__tip">只能上传pdf文件</div>
          </el-upload>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="uploadVisible = false">取 消</el-button>
        <el-button
          :loading="uploadLoading"
          type="primary"
          @click="handleUpload"
        >
          确 认
        </el-button>
      </template>
    </el-dialog>
    <refund ref="refund" />
    <pdf ref="pdf" />
  </div>
</template>

<script>
import moment from 'moment'
import lodash from 'lodash'
import {
  getApartmentOrder,
  verifyApartmentOrder,
  updateApartmentOrder,
  cancelApartmentOrder,
} from '@/api/order'
import { getUploadToken } from '@/api/app'
import { orderChannels } from '@/utils/const'
import { filterPrice, checkOrderVerify, checkRefundAmount } from '@/utils/tool'
import Refund from './refund.vue'
import store from 'store'
import { bank } from '@/utils/bank'
import { QNUploadURL, QNHost } from '@/config/net.config'
export default {
  name: 'ApartmentDetail',
  components: { Refund },
  emits: ['fetch-data'],
  data() {
    return {
      moment,
      bank,
      QNUploadURL,
      QNHost,
      receiptToken: '',
      tutorialToken: '',
      showForm: {},
      productList: [],
      refundList: [],
      dialogFormVisible: false,
      verifyLoading: false,

      refundVisible: false,
      refundLoading: false,
      refundAmount: 0,

      confirmVisible: false, // 确认弹窗
      confirmLoading: false,
      confirmAmount: '', // 定金金额

      uploadVisible: false, // 上传收据和手册弹窗
      uploadLoading: false,
      receipt: '', // 收据pdf
      tutorial: '', // 网站注册知道手册

      receiptForm: {
        file: '',
        fileList: [],
      },
      tutorialForm: {
        file: '',
        fileList: [],
      },
      pdfUrl: '',
      showUpload:true
    }
  },
  methods: {
    // 格式化订单支付方式
    formatChannel(row) {
      const channel = (row && row.payment && row.payment.channel) || 'UNKOWN'
      return orderChannels[channel]
    },
    tokf() {
      // this.$router.push(`/customer/chat?peopleId=${this.showForm.basic&&this.showForm.basic.peopleId}`)
      this.$router.push({name:'Chat',params: { peopleId: this.showForm.basic&&this.showForm.basic.peopleId }})
      this.close()
    },
    // 格式化金额
    formatPrice(price) {
      return filterPrice(price)
    },
    formatBank(form) {
      const type = (form && form.payment && form.payment.bankType) || ''
      return bank[type] || ''
    },
    // 检查是否能退款
    checkRefund() {
      return [2, 3, 4].includes(this.showForm.step)
    },
    // 上传pdf
    beforeUpload(file) {
      console.log('file type', file)
      const isExcel = file.type === 'application/pdf'
      const isLt5MB = file.size / 1024 / 1024 / 1024 < 0.5

      if (!isExcel) {
        this.$message.error('上传文件只能是 PDF 格式!')
      }
      if (!isLt5MB) {
        this.$message.error('上传文件大小不能超过 5MB!')
      }
      return isExcel && isLt5MB
    },
    uploadReceiptSuccess(res) {
      if (!res.hash) {
        this.$message.error('上传失败')
        return
      }
      this.receipt = `${QNHost}/${res.hash}`
    },
    uploadTutorialSuccess(res) {
      if (!res.hash) {
        this.$message.error('上传失败')
        return
      }
      this.tutorial = `${QNHost}/${res.hash}`
    },
    // 查看pdf
    handlePdf(url) {
      window.open(url, '_blank')
    },
    // 确认订单
    async confirmOrder() {
      if (!this.confirmAmount || this.confirmAmount <= 0) {
        this.$message.error('请输入正确的金额')
        return
      }
      this.confirmLoading = true
      const result = updateApartmentOrder({
        orderId: this.showForm.orderId,
        step: 1,
        amount: this.confirmAmount,
      })
      if (!!result) {
        this.confirmVisible = false
        this.dialogFormVisible = false
        this.$message.success('订单确认成功')
        this.$emit('fetch-data')
      }
    },
    handleCancel() {
      this.$confirm(
        `确定取消订单‘<span style="color: #f56c6c">${this.showForm.title}</span>’吗？`,
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          dangerouslyUseHTMLString: true,
          type: 'warning',
        }
      ).then(() => {
        cancelApartmentOrder({
          orderId: this.showForm.orderId,
        }).then((res) => {
          if (!res) return
          this.dialogFormVisible = false
          this.$message.success('订单取消成功')
          this.$emit('fetch-data')
        })
      })
    },
    // 上传手册
    async handleUpload() {
      // if (!this.receipt) {
      //   this.$message.error('请上传订单收据')
      //   return
      // }
      if (!this.tutorial) {
        this.$message.error('请上传注册指导手册')
        return
      }
      this.uploadLoading = true
      const result = await updateApartmentOrder({
        orderId: this.showForm.orderId,
        receipt: this.receipt,
        tutorial: this.tutorial,
        step: 3,
      })
      this.uploadLoading = false
      if (!!result) {
        this.uploadVisible = false
        this.dialogFormVisible = false
        this.$message.success('上传成功')
        this.$emit('fetch-data')
      }
    },
    // 核销订单
    async verifyOrder() {
      this.$confirm(
        `确定完成订单‘<span style="color: #f56c6c">${this.showForm.title}</span>’吗？`,
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          dangerouslyUseHTMLString: true,
          type: 'warning',
        }
      ).then(() => {
        verifyApartmentOrder({
          orderId: this.showForm.orderId,
        }).then((res) => {
          if (!res) return
          this.dialogFormVisible = false
          this.$message.success('订单完成成功')
          this.$emit('fetch-data')
        })
      })
    },
    // 订单退款
    handleRefund() {
      this.$refs.refund.showRefund(this.showForm)
    },
    async show(row) {
      this.showUpload=!(store.get('appId')=="63f34d56301610e24109df37")
      const data = await getApartmentOrder({
        orderId: row.orderId,
      })
      const receipt = await getUploadToken({})
      const tutorial = await getUploadToken({})
      this.receiptToken = { token: receipt.token }
      this.tutorialToken = { token: tutorial.token }
      this.showForm = data
      this.dialogFormVisible = true
    },
    close() {
      this.dialogFormVisible = false
    },
  },
}
</script>

<style lang="scss" scoped>
.fix-width {
  width: 220px;
}

.order-no {
  font-size: 18px;
  margin: 0;
}

.main-task {
  border: 2px dashed #f56c6c;
  box-sizing: border-box;
  padding: 10px;
  margin: 10px 0;
  overflow: hidden;
}

.single-product {
  border-bottom: 1px dashed #333333;
  margin-bottom: 10px;
  padding-bottom: 10px;
}

.el-row {
  padding: 10px 0;
}

.express_item {
  & + .express_item {
    margin-top: 10px;
  }

  span {
    font-weight: 600;
  }
}
</style>
